import React from 'react'
import PropTypes from 'prop-types'

import FieldFeedback from './FieldFeedback'
import styled from 'styled-components'

const StyledFieldError = styled(FieldFeedback)`
  margin: 7px 0;
  p {
    margin: 0;
    line-height: 100%;
  }
  div {
    display: flex;
  }
`

const FieldError = ({ children, ...rest }) => (
  <StyledFieldError type='error' {...rest}>
    {children}
  </StyledFieldError>
)

FieldError.propTypes = {
  children: PropTypes.node
}

export default FieldError
